<template>
    <div class="role-info">
        <div style="height:50px;line-height:50px;padding-left:15px;background:#fff;">
            <span style="color:rgba(18, 18, 18, 1);font-size:14px;font-weight:bold;">角色信息</span>
            <a-button @click="addRole" type="primary" icon="plus" style="float:right;margin:12px 24px 0 0;height:26px;line-height:26px;font-size:13px;">
            新增
            </a-button>
        </div>
        <div style="display:flex;flex:1;padding:16px 24px 24px 16px;">
            <div style="background:#fff;width:100%;height:100%;overflow:auto;padding:24px;">
                <div>
                    <a-row>
                        <a-col :span="6">
                            <span style="color:rgba(18, 18, 18, 1);font-size:13px;margin-right:8px;">角色名称：</span>
                            <a-input v-model="queryInfo.roleName" style="width:200px;" placeholder="请输入" />
                        </a-col>
                        <a-col :span="6">
                            <span style="color:rgba(18, 18, 18, 1);font-size:13px;margin-right:8px;">创建人：</span>
                            <a-input v-model="queryInfo.createBy" style="width:200px;" placeholder="请输入" />
                        </a-col>
                        <a-col :span="10">
                            <span>创建时间：</span>
                            <a-range-picker @change="changeDate"  style="width:320px;" format="YYYY-MM-DD HH:mm:ss" />
                        </a-col>
                        <a-col :span="2">
                            <a-button @click="queryBasicInfo" style="float:right;" type="primary">
                            查询
                            </a-button>
                        </a-col>
                    </a-row>
                </div>
                <div style="margin-top:20px;">
                    <a-table bordered  
                        :data-source="tableData" 
                        :pagination='false' 
                        class="cloudy-table" 
                        :rowKey="(record,index)=>{return index}"
                    >
                        <a-table-column key="name" title="角色名称" data-index="name">
                            <template slot-scope="text, record">
                                <div>{{record.name}}</div>
                            </template>
                        </a-table-column>
                        <a-table-column key="createBy" title="创建人" data-index="createBy">
                            <template slot-scope="text, record">
                                <div>{{record.createBy}}</div>
                            </template>
                        </a-table-column>
                        <a-table-column key="createTime" title="创建时间" data-index="createTime">
                            <template slot-scope="text, record">
                                <div>{{record.createTime}}</div>
                            </template>
                        </a-table-column>
                        <a-table-column key="updateTime" title="修改时间" data-index="updateTime">
                            <template slot-scope="text, record">
                                <div>{{record.updateTime}}</div>
                            </template>
                        </a-table-column>
                        <a-table-column key="isSuperAdmin" title="是否超级管理员" data-index="isSuperAdmin">
                            <template slot-scope="text, record">
                                <div>{{record.isSuperAdmin==1?'是':'否'}}</div>
                            </template>
                        </a-table-column>
                        <a-table-column key="id" title="操作" data-index="id">
                            <template slot-scope="text, record">
                                <span style="cursor:pointer;color:#1890ff" @click="changeRoleInfo(record.id, record.name, record.isSuperAdmin)">修改</span>
                            </template>
                        </a-table-column>
                    </a-table>
                </div>
            </div>
        </div>
       <a-modal v-model="roleModalBool" class="chat-modal" footer='' width='980px' :closable='false'>
            <div>
                <div style="height:54px;line-height:54px;padding:0 20px 0 24px;">
                    <span style="color:rgba(18, 18, 18, 1);font-size:14px;font-weight:bold;">角色权限</span>
                    <a-icon @click="offAddRole" style="color:rgba(158, 172, 196, 1);font-size:16px;float:right;margin-top:20px;cursor:pointer;" type="close" />
                </div>
                <div style="padding:20px 24px 27px;border-top:1px solid rgba(229, 229, 229, 1);border-bottom:1px solid rgba(229, 229, 229, 1);">
                    <div style="height:71px;padding:19px 0 0 0">
                        <div style="display:inline-block;">
                            <span style="color:rgba(158, 172, 196, 1);font-size:13px;">角色名称：</span>
                            <a-input v-model="roleJurisdiction.name" style="width:416px;height:32px;margin-left:8px;" placeholder="已输入的角色名称" />
                        </div>
                        <a-checkbox style="float:right;" v-model="roleJurisdiction.isSuperAdmin">
                            超级管理员
                        </a-checkbox>
                    </div>
                    <div>
                        <div>
                            <a-row class="word-head">
                                <a-col :span="3">
                                    模块名称
                                </a-col>
                                <a-col :span="2">
                                    查
                                </a-col>
                                <a-col :span="2">
                                    增
                                </a-col>
                                <a-col :span="2">
                                    改
                                </a-col>
                                <a-col :span="2">
                                    删
                                </a-col>
                                <a-col :span="13">
                                    非标功能
                                </a-col>
                            </a-row>
                        </div>
                        <div  class="word-body">
                            <a-checkbox-group style="width:100%" v-model="checkedDataList">
                                <a-row class="row-list" v-for="(item,index) in moduleFunData" :key='index'>
                                    <a-col :span="3"  class="field1">
                                        <div>{{item.moduleName}}</div>
                                    </a-col>
                                    <a-col :span="2"  class="field2">
                                        <a-checkbox v-if="item['查']['value']==undefined?false:true" class="checkbox-list" :value='item["查"]["value"]' :disabled='item["查"].isDisabled'>
                                            查
                                        </a-checkbox>
                                    </a-col>
                                    <a-col :span="2"  class="field2">
                                        <a-checkbox v-if="item['增']['value']==undefined?false:true" class="checkbox-list" :value='item["增"]["value"]' :disabled='item["增"].isDisabled'>
                                            增
                                        </a-checkbox>
                                    </a-col>
                                     <a-col :span="2"  class="field2">
                                        <a-checkbox v-if="item['改']['value']==undefined?false:true" class="checkbox-list" :value='item["改"]["value"]' :disabled='item["改"].isDisabled'>
                                            改
                                        </a-checkbox>
                                    </a-col>
                                    <a-col :span="2"  class="field2">
                                        <a-checkbox v-if="item['删']['value']==undefined?false:true" class="checkbox-list" :value='item["删"]["value"]' :disabled='item["删"].isDisabled'>
                                            删
                                        </a-checkbox>
                                    </a-col>
                                    <a-col :span="13"  class="field3">
                                        <div class="checkbox-list">
                                            <a-checkbox v-for="(item1,index1) in item['非标功能']" :key='index1' :value='item1["value"]' :disabled='item1.isDisabled'>
                                                {{item1.name}}
                                            </a-checkbox>
                                        </div>
                                        
                                    </a-col>
                                </a-row>
                            </a-checkbox-group>
                        </div>
                        
                    </div>
                </div>
                <div style="height:60px;padding:16px 24px 0 0;">
                    <div style="float:right">
                        <a-button @click="offAddRole" style="color:rgba(158, 172, 196, 1);font-size:13px;margin-right:8px;height:28px;line-height:28px;border:none;">取消</a-button>
                        <a-button @click="sureAddRole" type="primary" style="font-size:13px;height:28px;line-height:28px;border:none;">
                            确定
                        </a-button>
                    </div>
                </div>
            </div>
        </a-modal>
    </div>
</template>

<script>
    import moment from 'moment';
    export default {
        name: 'RoleInfo',
        data() {
            return {
                roleModalBool: false,
                checkedDataList: [],
                queryInfo: {
                    roleName: '',
                    createBy: '',
                    startTime: '',
                    endTime: '',
                },
                tableData: [],
                moduleFunData: [],
                roleJurisdiction: {
                    id: '',
                    name: '',
                    isSuperAdmin: false,
                },
            }   
        },
        methods: {
            moment,
            queryBasicInfo() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/role/list', 
                        params: {
                            name: this.queryInfo.roleName,
                            createBy: this.queryInfo.createBy,
                            beginTime: this.queryInfo.startTime,
                            endTime: this.queryInfo.endTime,
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.tableData = response.data.data.records
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            changeDate(date, dateString) {
                console.log(date, dateString);
                this.queryInfo.startTime = dateString[0]
                this.queryInfo.endTime = dateString[1]
            },
            addRole() {
                this.roleModalBool = true
                this.roleJurisdiction.id = ''
            },
            offAddRole() {
                this.roleModalBool = false
                this.checkedDataList = []
            },
            sureAddRole() {
                this.roleModalBool = false
                let arr = this.checkedDataList, brr = []
                for(let i = 0; i < arr.length; i++){
                    if(arr[i] != false){
                        brr.push(arr[i])
                    }
                }
                this.checkedDataList = brr
                this.axios.post('/api/role', {
                    id: this.roleJurisdiction.id,
                    name: this.roleJurisdiction.name,
                    isSuperAdmin: this.roleJurisdiction.isSuperAdmin,
                    functionList: this.checkedDataList,
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.$message.success(this.roleJurisdiction.id==''?'新增成功':'修改成功')
                        this.queryBasicInfo()
                        this.checkedDataList = []
                        this.roleJurisdiction = {
                            id: '',
                            name: '',
                            isSuperAdmin: false,
                        }
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            },
            changeRoleInfo(id, name, isSuperAdmin) {
                this.roleModalBool = true
                this.roleJurisdiction.id = id
                this.roleJurisdiction.name = name
                this.roleJurisdiction.isSuperAdmin = (isSuperAdmin==1?true:false)
                this.queryModuleFunList()
            },
            queryModuleFunList() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/role/functionList', 
                        params: {
                            roleId: this.roleJurisdiction.id
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.moduleFunData = response.data.data
                        let arr = response.data.data
                        this.checkedDataList = []
                        for(let i = 0; i < arr.length; i++){
                            if(arr[i]['删']['isSelected']){
                                this.checkedDataList.push(arr[i]['删']['value'])
                            }
                            if(arr[i]['增']['isSelected']){
                                this.checkedDataList.push(arr[i]['增']['value'])
                            }
                            if(arr[i]['改']['isSelected']){
                                this.checkedDataList.push(arr[i]['改']['value'])
                            }
                            if(arr[i]['查']['isSelected']){
                                this.checkedDataList.push(arr[i]['查']['value'])
                            }
                            for(let j = 0; j < arr[i]['非标功能'].length; j++){
                                if(arr[i]['非标功能'][j]['isSelected']){
                                    this.checkedDataList.push(arr[i]['非标功能'][j]['value'])
                                }
                            }
                        }
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },

        },
        mounted: function() {
            this.queryBasicInfo()
            this.queryModuleFunList()
        }
    }
</script>

<style scoped lang="less">
    .role-info{
        height: 100%;
        display: flex;
        flex-direction: column;
        background: rgba(240, 242, 243, 1);
    }
    .chat-modal{
        .name-list{
            overflow-y: auto;
            div{
                height: 48px;
                padding: 13px 0 0 20px;
                cursor: pointer;
                span:nth-child(1){
                    width: 24px;
                    height: 24px;
                    border-radius: 12px;
                    color: rgba(255, 255, 255, 1);
                    font-size: 12px;
                    margin-right: 8px;
                    background: rgba(78, 138, 250, 1);
                    display: inline-block;
                    text-align: center;
                    line-height: 24px;
                }
                span:nth-child(2){
                    color: rgba(18, 18, 18, 1);
                    font-size: 13px;
                }
            }
            div:hover{
                background: rgba(240, 242, 243, 0.5);
            }
        }
        .chat-tab{
            margin-top: 8px;
            span{
                display:inline-block;
                color: rgba(158, 172, 196, 1);
                font-size: 13px;
                cursor: pointer;
                padding-bottom: 6px;
                margin-right: 32px;
            }
            span.active{
                color: rgba(58, 220, 255, 1);
                font-weight: bold;
                border-bottom: 3px solid rgba(58, 220, 255, 1);
            }
        }
        .word-head{
            height: 50px;
            background: rgba(232, 235, 238, 1);
            line-height: 50px;
            text-align: center;
        }
        .word-body{
            max-height: 430px;
            overflow-y: auto;
            overflow-x: hidden;
            .row-list{
                border: 1px solid rgba(232, 235, 238, 1);
                border-right: none;
                border-top: none;
                height: 80px;
            }
            .field1{
                div{
                    height: 100%;
                    width: 100%;
                    text-align: center;
                    line-height: 80px;
                    // border-left: 1px solid rgba(232, 235, 238, 1);
                    // border-bottom: 1px solid rgba(232, 235, 238, 1);
                }
            }
            .field2{
                border-left: 1px solid rgba(232, 235, 238, 1);
                // border-bottom: 1px solid rgba(232, 235, 238, 1);
                display: inline-block;
                height: 100%;
                .checkbox-list{
                    height: 100%;
                    width: 100%;
                    text-align: center;
                    line-height: 80px;
                    margin-left: 0px !important;
                }
            }
            .field3{
                height: 100%;
                .checkbox-list{
                    display: block;
                    height: 100%;
                    width: 100%;
                    text-align: center;
                    line-height: 40px;
                    border-left: 1px solid rgba(232, 235, 238, 1);
                    // border-bottom: 1px solid rgba(232, 235, 238, 1);
                    margin-left: 0px !important;
                    border-right: 1px solid rgba(232, 235, 238, 1);
                }
            }
        }
    }
</style>